export default "__VITE_ASSET__BkUDi$pn__"